import { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { DotSpinner } from '@crono-one/design-system';

import PATH from 'crono-fe-common/constants/path';
import useOutlookAuthCallback from 'hooks/services/outlook/useOutlookAuthCallback';
import useOauthCallbackCode from 'pages/connect/views/useOauthCallbackCode';

const OUTLOOK_FROM_CALENDAR_KEY = 'outlookFromCalendar';

const OutlookLoginHandler: FC = () => {
  const location = useLocation();
  const { mutate: outlookAuthCallback } = useOutlookAuthCallback();

  // Resolved once on mount: the session flag is cleared on the way out, so
  // re-reading it on a later render would flip the destination to Mailbox.
  const [destination] = useState(() => {
    const { state } = queryString.parse(location.search);
    const sessionIntent = sessionStorage.getItem(OUTLOOK_FROM_CALENDAR_KEY);

    return state === 'calendar' || sessionIntent === 'true'
      ? PATH.SETTINGS.INTEGRATIONS.CALENDAR
      : PATH.SETTINGS.INTEGRATIONS.MAILBOX;
  });

  useOauthCallbackCode({
    provider: 'Outlook',
    exchangeCode: outlookAuthCallback,
    buildVariables: (code) => ({ code }),
    missingCodePath: destination,
    successPath: destination,
    errorPath: destination,
    cleanUp: () => sessionStorage.removeItem(OUTLOOK_FROM_CALENDAR_KEY),
  });

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default OutlookLoginHandler;
